import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { RouterParamsService } from '../../shared/services/router-params.service';
import {
  ExamRequest,
  ExamRequestDocumentLookup,
  toExamRequest,
} from '../models/exams';
import { BaseEntityService } from '../entity-management/services/base/base-entity.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ExamRequestsEntityService extends BaseEntityService<any> {

  constructor(
    httpClient: HttpClient,
    routerParamsService: RouterParamsService,
  ) {
    super(
      httpClient,
      environment.apiUrl, { singular: 'examRequest', plural: 'examRequests', url: 'exam-requests' },
      routerParamsService
    );
    this.nameId = 'examRequestId';
  }

  override getWithQuery(queryParams: Params, disableDefaultWrap: boolean = false): Observable<ExamRequest[]> {
    return super.getWithQuery(queryParams, disableDefaultWrap).pipe(
      map((examRequests) => examRequests.map((examRequest) => toExamRequest(examRequest)))
    );
  }

  regenerateDocument(examRequestId: number): Observable<any> {
    return this.httpClient
      .post(`${ this.entityUrl }/${ examRequestId }/regenerate-document`, {})
      .pipe(map((response: any) => response?.autoGenerate));
  }

  getDocumentUrl(documentLookup: ExamRequestDocumentLookup): Observable<string> {
    const { examGroup, personId } = documentLookup;
    const examRequest = {
      exam: {
        examGroup,
      },
      person: {
        id: personId,
      },
    };

    return this.httpClient
      .post(`${ this.entityUrl }/get-document-url`, { examRequest })
      .pipe(map((response: any) => response?.medicalDocument?.documentUrl));
  }
}
